export default __webpack_public_path__ + "static/media/back.c8576e64.svg";